<script setup lang="ts">
import { alert } from "@/services";
import { localize, openInNewTab } from "@/utils";
import SwiperCore from "swiper";
import { Mousewheel, Navigation, Pagination, Scrollbar } from "swiper/modules";
import { Swiper as SwiperClass } from "swiper/types";
import { Swiper, SwiperSlide } from "swiper/vue";
import { computed, onMounted, onUnmounted, reactive, Ref, ref } from "vue";

import HomeFooter from "@/views/home/HomeFooter.vue";
import HomeHeader from "@/views/home/HomeHeader.vue";
import router from "@/router";
import axios from "axios";
import { getDownloadCount } from "@/api/download/getDownloadCount";
import { APP_TYPE, PLATFORM_TYPE } from "@/api/type";
import { postDownloadApp } from "@/api/download/postDownloadApp";

SwiperCore.use([Mousewheel]);

const originRef = ref<HTMLElement | null>(null);
const floatRef = ref<HTMLElement | null>(null);
const mainSwiperRef = ref<SwiperClass | null>(null);
const scrollSwiperRef = ref<SwiperClass | null>(null);

//HERE
const downloadLink: Ref<string> = ref("https://download.r2playground.com");

const isMobile = computed(() => window.innerWidth < 992);
let lastOffset = 0;

const mainSwiperEvent = {
  init: function (swiper: SwiperClass) {
    mainSwiperRef.value = swiper;
  },
  slidechangetransitionstart: function (swiper: SwiperClass) {
    state.activeIndex = swiper.activeIndex;
    state.isEnd = state.activeIndex >= 6;
  },
  slideChangeTransitionEnd: function (swiper: SwiperClass) {
    const currentSlide = swiper.el.firstElementChild?.children[swiper.activeIndex];
    if (window.innerWidth < 992 && currentSlide?.classList.contains("main-system")) {
      swiper.mousewheel.disable();
      scrollSwiperRef.value?.mousewheel?.enable();
    }
  },
  slideChange: function (swiper: SwiperClass) {
    const currentSlide = swiper.el.firstElementChild?.children[swiper.activeIndex];
    state.isDarkMode = currentSlide?.classList.contains("sect-dark") == true;
  },
  setTranslate: function (swiper: SwiperClass) {
    // state.isEnd = swiper.isEnd;
    // state.isEnd = state.activeIndex >= 5;
  },
};
const scrollSwiperEvent = {
  init: function (swiper: SwiperClass) {
    scrollSwiperRef.value = swiper;
  },
  setTranslate: function (scrollSwiper: SwiperClass) {
    if (isMobile) {
      const nowOffset = scrollSwiper.el.offsetTop;
      const endOffset = window.innerHeight - scrollSwiper.el.clientHeight + 10;

      if (nowOffset < lastOffset && nowOffset < endOffset) {
        scrollSwiperEvent.moveParent(scrollSwiper, nowOffset);
        mainSwiperRef.value?.slideNext();
      } else if (nowOffset > lastOffset && nowOffset > 51) {
        scrollSwiperEvent.moveParent(scrollSwiper, nowOffset);
        mainSwiperRef.value?.slidePrev();
      }
      lastOffset = scrollSwiper.el.offsetTop;
    }
  },
  moveParent: function (scrollSwiper: SwiperClass, nowOffset: number) {
    scrollSwiper.mousewheel.disable();
    mainSwiperRef.value?.mousewheel.enable();
    lastOffset = nowOffset;
  },
};

const state = reactive({
  isDarkMode: false,
  isEnd: false,
  activeIndex: 0,
});

// init();
// onMounted(init);
requestAnimationFrame(() => {
  setTimeout(init, 500);
  // nextTick();
  // init();
});

onUnmounted(() => {
  if (resizeHandler) {
    window.removeEventListener("resize", resizeHandler);
  }
});

function init() {
  window.addEventListener("resize", resizeHandler);
  resizeHandler();
}
function resizeHandler() {
  floatRef.value?.style.setProperty("--right", `${originRef.value?.offsetLeft}px`);
  floatRef.value?.style.setProperty("--bottom", `${originRef.value?.offsetTop}px`);
}
const openYouTube = () => {
  window.open('https://www.youtube.com/@r2gatetv', '_blank');
};
function openDownloadPage() {
  window.open(downloadLink.value);
}

function goToDownloadSection(hash: string) {
  router.push({ path: '/home/solution', hash });
}

interface DownloadResponse {
  success: boolean
  data: string
  message?: string
}

const downloadSectionRef = ref<HTMLElement | null>(null)

let downloadObserver: IntersectionObserver | null = null
let isDownloadCountLoaded = false

const observeDownloadSection = () => {
  if (!downloadSectionRef.value) return

  downloadObserver = new IntersectionObserver(
    async (entries) => {
      const entry = entries[0]

      if (entry.isIntersecting && !isDownloadCountLoaded) {
        isDownloadCountLoaded = true

        await loadAllDownloadCounts()

        downloadObserver?.disconnect()
      }
    },
    {
      threshold: 0.2
    }
  )

  downloadObserver.observe(downloadSectionRef.value)
}

// 특정 타입 카운트 갱신 함수
const updateDownloadCount = async (type: APP_TYPE) => {
  try {
    if (!type) return
    const res = await getDownloadCount({
      type: type
    })
    const el = document.querySelector(`.count-num[data-type="${type}"]`) as HTMLElement
    if (el) {
      const formattedCount = String(res.data.count).padStart(5, '0')
      el.textContent = `(${formattedCount})`
    }
  } catch (err) {
    console.error(`다운로드 카운트 API 호출 실패 (${type}):`, err)
  }
}

// 모든 타입 카운트 초기 로딩
const loadAllDownloadCounts = async () => {
  const elements = document.querySelectorAll(
    '.count-num'
  ) as NodeListOf<HTMLElement>

  for (const el of Array.from(elements)) {
    const type = el.dataset.type

    if (!type) continue

    await updateDownloadCount(type as APP_TYPE)
  }
}

// 페이지 로드 시 실행
onMounted(async () => {
  // 최초 진입 시 카운트 로드
  await loadAllDownloadCounts()

  // 스크롤 영역 감지 시작
  observeDownloadSection()
})

onUnmounted(() => {
  if (resizeHandler) {
    window.removeEventListener('resize', resizeHandler)
  }

  downloadObserver?.disconnect()
})

// 앱 다운로드
  const onClickAppDownload = async (app: APP_TYPE, platform: PLATFORM_TYPE) => {
    const res = await postDownloadApp({
      downloadType: app,
      platformType: platform,
      usedLocationType: "VISITOR_WEB_APP",
    });
    if (res.isSuccess) {
      const link = document.createElement('a')
      link.href = res.data.url
      link.setAttribute('download', '')
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      updateDownloadCount(app)
    } else {
      alert('다운로드 링크를 가져오지 못했습니다.')
    }
  }

</script>

<template>
  <div id="wrap" :data-swiper="state.activeIndex" :class="{ 'dark-mode': state.isDarkMode, 'is-end': state.isEnd }">
    <!-- header -->
    <home-header />
    <!-- //header -->

    <!-- container -->
    <main id="ct">
      <!-- 페이지 시작 -->

      <swiper
        class="main-swiper"
        direction="vertical"
        :mousewheel="true"
        :speed="1000"
        slides-per-view="auto"
        :resistance-ratio="0"
        :simulate-touch="false"
        :modules="[Navigation]"
        :initial-slide="0"
        :navigation="{
          nextEl: '.main-swiper>.swiper-button-next',
        }"
        @init="mainSwiperEvent.init"
        @slide-change-transition-start="mainSwiperEvent.slidechangetransitionstart"
        @slide-change-transition-end="mainSwiperEvent.slideChangeTransitionEnd"
        @slide-change="mainSwiperEvent.slideChange"
        @setTranslate="mainSwiperEvent.setTranslate"
      >
              <swiper-slide class="main-sect main-visual" :key="0">
          <div class="container">
            <div class="main-visual-text ani ani-ink-right">
              <div class="nav-card-grid">
                <div class="nav-card" @click.prevent="openDownloadPage">  
                  <div>
                    <h5 class="nav-card__title">R2iOS install Package</h5>
                    <p class="nav-card__content"
                      v-html="
                        localize('R2iOS 구매유저만 설치를 할 수 있습니다.<br/>R2iOS 시리얼 번호를 미리 준비해 주세요.') 
                      "
                    />
                  </div>
                  <div class="nav-card__action">
                    <div class="r2ios-logo-img-group">
                          <img src="@/assets/home/img/nav-r2ios.png" class="r2i3-logo-top-logo" alt="" />

                          <div class="sub-logo-group">
                            <img src="@/assets/home/img/nav-chitok.png" class="sub-logo" alt="" />
                            <img src="@/assets/home/img/nav-pingpong.png" class="sub-logo" alt="" />
                          </div>
                    </div>
                  </div>
                </div>          
                <div class="nav-card" @click="goToDownloadSection('#solution-facegide-lite')"> 
                  <div>
                    <h5 class="nav-card__title">FaceGIDE Lite</h5>
                    <p class="nav-card__content"
                      v-html="
                        localize('Face GIDE Set up 확인!<br/>Set up 수정, 컨펌 등 쉽게 센터와 소통이<br/>가능합니다.')
                      "
                    /> 
                  </div>
                  <div class="nav-card__action">
                    <div class="nav-card__content-img-group">
                      <img src="@/assets/home/img/nav-fg-lite.png" class="nav-card-app-img" alt="" />
                    </div>
                  </div>
                </div>             
              </div>
              <div class="nav-card-grid"> 
                <div class="nav-card download" @click="onClickAppDownload('PINGPONG', 'windows')"> 
                  <div>
                    <h5 class="nav-card__title">Ping Pong</h5>
                    <p class="nav-card__content"
                      v-html="localize('Ping! 주문을 보내면, Pong! 주문,컨펌,채팅을<br/>한번에!<br/>스마트한 디지털 Workflow를 경험해보세요.')"              
                    />
                  </div>
                  <div class="nav-card__action" >
                    <div class="nav-card__content-img-group">
                      <img src="@/assets/home/img/nav-pingpong.png" class="nav-card-app-img" alt="" />
                    </div>
                  </div>
                </div> 
                <div class="nav-card" @click="goToDownloadSection('#solution-r2gate-sa')"> 
                  <div>
                    <h5 class="nav-card__title">R2GATE SA</h5>
                    <p class="nav-card__content"
                       v-html="
                        localize(
                          'R2GATE SA, 기다림은 끝났습니다.<br/>지금 다운로드하고 성공적인 임플란트<br/>플랜을 시작하세요.')
                       "
                    />
                  </div>
                  <div class="nav-card__action">
                    <div class="nav-card__content-img-group">
                      <img src="@/assets/home/img/nav-r2sa.png" class="nav-card-app-img" alt="" />
                    </div>
                  </div>
                </div>       
              </div>
              <div class="nav-card-grid">
                <div class="nav-card"  @click="goToDownloadSection('#solution-r2-pros-lite')"> 
                  <div>
                    <h5 class="nav-card__title">R2 Pros Lite</h5>
                    <p class="nav-card__content"
                      v-html="
                        localize('편리한 보철 디자인 확인, Pros lite를 설치해<br/>보세요. 디자인 확인, 컨펌, 코멘트 등 다양한 기<br/>능이 포함되어 있습니다.') 
                      " 
                    />
                  </div>
                  <div class="nav-card__action">
                    <div class="nav-card__content-img-group">
                      <img src="@/assets/home/img/nav-pros-lite.png" class="nav-card-app-img" alt="" />
                    </div>
                  </div>
                </div> 
                <div class="nav-card" @click="goToDownloadSection('#solution-r2gate-lite-sa')"> 
                  <div>
                    <h5 class="nav-card__title">R2GATE Lite SA</h5>
                    <p class="nav-card__content"
                       v-html="
                        localize('R2GATE Lite SA로 임플란트 진단을 더<br/>빠르고 간단하게 확인하세요.')
                       "
                    />
                  </div>
                  <div class="nav-card__action">
                    <div class="nav-card__content-img-group">
                      <img src="@/assets/home/img/nav-r2gate-lite-sa.png" class="nav-card-app-img" alt="" />
                    </div>
                  </div>
                </div>        
              </div>
              <div class="nav-card-grid">
                <div class="nav-card" @click="goToDownloadSection('#solution-r2-ortho-lite')"> 
                  <div>
                    <h5 class="nav-card__title">R2 Ortho Lite</h5>
                    <p class="nav-card__content"
                       v-html="
                        localize('MEG Aligner Set up 확인!<br/>Set up 수정, 컨펌 등 쉽게 센터와 소통이 가능<br/>합니다.')
                       "
                    />
                  </div>
                  <div class="nav-card__action">
                    <div class="nav-card__content-img-group">
                      <img src="@/assets/home/img/nav-megaligner-lite.png" class="nav-card-app-img" alt="" />
                    </div>
                  </div>
                </div>   
              </div>
              <div class="nav-card sign-up" @click.prevent="router.push('/home/join')"> 
                <h5 class="sign-up-title">{{ localize("회원가입 바로가기") }}</h5>
              </div>              
            </div>
            
            <div class="visual-illu" >
              <i class="villu-r"></i>
              <i class="villu1 ani"></i>
              <i class="villu2 ani"></i>
              <i class="villu3 ani"></i>
              <i class="villu3-2 ani"></i>
              <i class="villu4 ani"></i>
              <i class="villu5 ani"></i>
              <i class="villu-2"></i>
              <i class="villu6 ani"></i>
              <i class="villu7 ani"></i>
              <div class="sns-logo-group">
                <a href="https://www.youtube.com/@r2gatetv" target="_blank">
                  <img src="@/assets/home/img/main/sns-youtube.png" alt="Youtube Logo" />
                </a>
                <a href="https://www.instagram.com/r2playground?igsh=bXR1aWNoNnpibTFi" target="_blank">
                  <img src="@/assets/home/img/main/sns-instagram.png" alt="Instagram Logo" />
                </a>
                <a href="https://m.facebook.com/r2gate/" target="_blank">
                  <img src="@/assets/home/img/main/sns-facebook.png" alt="FaceBook Logo" />
                </a>
              </div>
            </div>
          </div>
        </swiper-slide>
        <swiper-slide class="main-sect main-visual" :key="1">
          <div class="container">
            <div class="main-visual-text ani ani-ink-right">
              <h1 class="heading">Let's play<br />Together</h1>
              <strong class="fs-4">{{ localize("지식과 디자인을 주문하다!") }}</strong>
              <p
                v-html="localize('R2 Playground는 맞춤형 디지털 진단 및 <br class=\'d-none d-lg-block\' />치료계획을 위한 다양한 임상 솔루션과 디자인 서비스를 제공합니다.')
                "
              ></p>
              <div class="together-btn-group">
                <router-link to="/home/playground/player">
                  <button class="btn btn-primary custom-min-width">
                  {{ localize("R2 Player") }}
                  </button>
                </router-link>
                <router-link to="/home/playground/planner">
                  <button class="btn btn-primary custom-min-width">
                  {{ localize("R2 Planner") }}
                  </button>
                </router-link>
                <router-link to="/home/playground/r2center">
                  <button class="btn btn-primary custom-min-width">
                  {{ localize("R2 Center") }}
                  </button>
                </router-link>                
              </div>
            </div>
            <div class="visual-illu">
              <i class="villu-r"></i>
              <i class="villu1 ani"></i>
              <i class="villu2 ani"></i>
              <i class="villu3 ani"></i>
              <i class="villu3-2 ani"></i>
              <i class="villu4 ani"></i>
              <i class="villu5 ani"></i>
              <i class="villu-2"></i>
              <i class="villu6 ani"></i>
              <i class="villu7 ani"></i>
            </div>
          </div>
        </swiper-slide>
        <swiper-slide class="main-sect sect-dark main-solution" :key="2">
          <div class="container">
            <div class="position-relative">
              <h2 class="main-solution-title fs-2">
                Enjoy R2 Solutions
                <img src="@/assets/home/img/main/solution1.svg" class="ani" alt="" />
                <img src="@/assets/home/img/main/solution2.svg" class="ani" alt="" />
              </h2>
              <p
                v-html="
                  localize('디지털 솔루션의 모든 것.<br/>임플란트, 무치악 수복, 양약, 교정, 보철 디자인에 필요한 모든 솔루션을 제공합니다.')
                "
              ></p>
              <div class="swiper-button-wrap">
                <div class="swiper-button-prev"></div>
                <div class="swiper-button-next"></div>
              </div>
            </div>
            <swiper
              class="solution-swiper overflow-visible"
              :slides-per-view="1.08"
              :space-between="20"
              :grab-cursor="true"
              :breakpoints="{
                768: {
                  slidesPerView: 2.2,
                  spaceBetween: 30,
                },
                1024: {
                  slidesPerView: 3.25,
                  spaceBetween: 60,
                },
              }"
              :modules="[Navigation, Pagination]"
              :navigation="{
                nextEl: '.main-solution .swiper-button-next',
                prevEl: '.main-solution .swiper-button-prev',
              }"
              :pagination="{
                el: '.main-solution .swiper-pagination',
                type: 'progressbar',
              }"
            >
              <swiper-slide>
                <div class="card">
                  <!-- <div class="card-img"><img src="@/assets/home/img/main/solution1.png" alt="" /></div> -->
                  <div class="card-img embed-responsive">
                      <video src="https://playgroundmaintenance.blob.core.windows.net/webstaticassets/Video/R2_Impalant_solution/20190218_R2GUIDE_AD_EN.mp4" class="embed-responsive-item" autoplay muted></video>
                  </div>
                  <strong>{{ localize("R2 Implant") }}</strong>
                  <p class="card-text"
                      v-html="
                      localize('임플란트 진단 및 수술계획<br/>Digital Eye를 통해 시술부위의 골질을 정확하게 분석하고, 최적의 초기 고정을 위한 Drilling sequence 리포트를 제공합니다. 진단 후 R2AID를 이용하여 수술용 가이드도 제작할 수 있습니다.')
                      "
                  />
                  <router-link
                    :to="{ name: 'home-r2-solution', query: { section: 0 } }"
                    class="btn btn-outline-white btn-sm"
                    >View more<i class="icon icon-arrow"></i
                  ></router-link>
                </div>
              </swiper-slide>
              <swiper-slide>
                <div class="card">
                  <!-- <div class="card-img"><img src="@/assets/home/img/main/solution2-1.png" alt="" /></div> -->
                  <div class="card-img embed-responsive">
                      <video src="https://playgroundmaintenance.blob.core.windows.net/webstaticassets/Video/Digital_Oral_Design_Solution/DOD_Solution_241014.mp4" class="embed-responsive-item" autoplay muted></video>
                  </div>
                  <strong>{{ localize("R2 QVD") }}</strong>
                  <p class="card-text"
                      v-html="
                      localize('무치악 솔루션의 새로운 페러다임<br/>복잡한 사전 준비 없이, R2StudioQ와 QVD를 통해 디지털 환자 분석, VD 결정, 임플란트 수술 계획 및 임시 보철 디자인까지 한 번에 완성할 수 있습니다.')
                      "
                  />
                  <router-link
                    :to="{ name: 'home-r2-solution', query: { section: 1 } }"
                    class="btn btn-outline-white btn-sm"
                    >View more<i class="icon icon-arrow"></i
                  ></router-link>
                </div>
              </swiper-slide>
              <swiper-slide>
                <div class="card">
                  <!-- <div class="card-img">
                    <div class="solution-swiper-img4"></div>
                  </div> -->
                  <div class="card-img embed-responsive">
                      <video src="https://playgroundmaintenance.blob.core.windows.net/webstaticassets/Video/Meg_Aligner/Main_megaligner.mp4" class="embed-responsive-item" autoplay muted></video>
                  </div>
                  <strong>{{ localize("Meg Aligner") }}</strong>
                  <p class="card-text"
                      v-html="
                      localize('임플란트·보철을 위한 투명교정 솔루션<br/>치아 이상 배열, 위치 문제로 임플란트나 보철 치료에 어려움이 있다면, 맥얼라이너가 도와드립니다. 효과적인 포인트 교정과 단기 교정을 통해 심미적이고 완성도 높은 치료가 가능해집니다.')
                      "
                  />
                  <router-link
                    :to="{ name: 'home-r2-solution', query: { section: 2 } }"
                    class="btn btn-outline-white btn-sm"
                    >View more<i class="icon icon-arrow"></i
                  ></router-link>
                </div>
              </swiper-slide>
              <swiper-slide>
                <div class="card">
                  <!-- <div class="card-img"><img src="@/assets/home/img/main/solution5.png" alt="" /></div> -->
                  <div class="card-img embed-responsive">
                      <video src="https://playgroundmaintenance.blob.core.windows.net/webstaticassets/Video/R2CAD/R2solution_R2cadcam.mp4" class="embed-responsive-item" autoplay muted></video>
                  </div>
                  <strong>{{ localize("R2CAD/CAM") }}</strong>
                  <p class="card-text"
                    v-html="
                      localize(
                        '간단하고 빠른 체어사이드 CAD<br/>임시치아와 커스텀 어버트먼트 디자인에 꼭 필요한 기능만 담았습니다.<br/>치과에서 빠르게 완성할 수 있는 실용적인 CAD 솔루션입니다.'
                      )
                    "
                  />
                  <router-link
                    :to="{ name: 'home-r2-solution', query: { section: 3 } }"
                    class="btn btn-outline-white btn-sm"
                    >View more<i class="icon icon-arrow"></i
                  ></router-link>
                </div>
              </swiper-slide>
              <swiper-slide>
                <div class="card">
                  <!-- <div class="card-img"><img src="@/assets/home/img/main/solution3.png" alt="" /></div> -->
                  <div class="card-img embed-responsive">
                      <video src="https://playgroundmaintenance.blob.core.windows.net/webstaticassets/Video/FaceGIDE_Solution/IDS_FG_FINAL190228_vol.2.mp4" class="embed-responsive-item" autoplay muted></video>
                  </div>
                  <strong>{{ localize("FaceGIDE") }}</strong>
                  <p class="card-text"
                      v-html="
                      localize('직관적인 양악 수술 계획<br/>Jaw segmentation과 setup을 통해 정확한 진단과 수술 계획을 수립할 수 있습니다. 환자 맞춤형 플레이트와 Saw Guide로 더욱 안전하고 정밀한 양악 수술이 가능합니다.')
                      "
                  />
                  <router-link
                    :to="{ name: 'home-r2-solution', query: { section: 4 } }"
                    class="btn btn-outline-white btn-sm"
                    >View more<i class="icon icon-arrow"></i
                  ></router-link>
                </div>
              </swiper-slide>
              <swiper-slide>
                <div class="card">
                  <div class="card-img">
                    <div class="solution-swiper-img6"></div>
                  </div>
                  <strong>{{ localize("MegaGEN Digital Library") }}</strong>
                  <p class="card-text"
                    v-html="
                    localize(
                        '다양한 CAD 라이브러리 지원<br/>디지털 보철 제작을 위한 EXOCAD, 3Shape 등 다양한 CAD 라이브러리를 제공합니다.<br/>스캔 어버트먼트를 이용한 정규 라이브러리뿐 아니라, 특수 목적의 맞춤형 라이브러리도 지원합니다.'
                      )
                    "
                  /> 
                  <a href="https://r2gate.com/cad-cam?cate=3shape" target="_blank" class="btn btn-outline-white btn-sm">
                    View more<i class="icon icon-arrow"></i>
                  </a>
                  <!-- <router-link
                    :to="{ name: 'home-r2-solution', query: { section: 5 } }"
                    class="btn btn-outline-white btn-sm"
                    >View more<i class="icon icon-arrow"></i
                  ></router-link> -->
                </div>
              </swiper-slide>
              <div class="swiper-pagination"></div>
            </swiper>
          </div>
        </swiper-slide>
        <swiper-slide class="main-sect main-system" :key="3">
          <swiper
            class="scrollSwiper"
            direction="vertical"
            :slides-per-view="'auto'"
            :free-mode="true"
            :modules="[Scrollbar]"
            :scrollbar="{
              el: '.swiper-scrollbar',
            }"
            @init="scrollSwiperEvent.init"
            @set-translate="scrollSwiperEvent.setTranslate"
          >
            <swiper-slide>
              <div class="container">
                <div class="main-system-hd">
                  <div class="main-system-title w-100">
                    <p>{{ localize("빠르고, 편리한 그리고 세계적인") }}</p>
                    <h2 class="fs-2">R2 Playground</h2>
                    <div class="d-flex w-100 justify-content-between">
                      <strong class="font-poppins">Online order system</strong>
                      <div>
                        <button class="btn btn-primary" @click.prevent="alert('준비 중 입니다.')">{{ localize("바로 주문하기") }}<i class="icon icon-arrow"></i></button>
                        <!-- <button class="btn btn-outline-primary">{{ localize("Pingpong 다운로드") }}<i class="icon icon-download"></i></button> -->
                      </div>
                    </div>
                  </div>
                  <p class="d-none d-lg-block ml-auto">
                    <!--<a @click="openInNewTab('/playground/player/order')" class="btn btn-primary"
                      >{{ localize("바로 주문하기") }}<i class="icon icon-arrow"></i
                    ></a>
                    <button @click="alert(localize('준비 중 입니다.'))" class="btn btn-outline-primary">
                      {{ localize("Playground 다운로드") }}<i class="icon icon-download"></i>
                    </button>-->
                  </p>
                </div>
                <ul class="row no-gutters main-system-item">
                  <li class="col-lg-4">
                    <img src="@/assets/home/img/main/system-1.svg" class="ani" alt="" />
                    <strong class="fs-4">{{ localize("R2iOS로 Ping하면, 결과가 Pong!") }}</strong>
                    <p
                      class="fsmall"
                      v-html="
                        localize('R2i3/R2i5 스캔만으로 진단, 디자인, 수술 가이드<br/>및 보철물 주문까지 한번에.<br/>전용 Pingpong 앱으로 주문 진행 상황도<br/>손쉽게 확인하세요.')
                      "
                    ></p>
                  </li>
                  <li class="col-lg-4">
                    <img src="@/assets/home/img/main/system-2.svg" class="ani" alt="" />
                    <strong class="fs-4">{{ localize("가이드, 보철 디자인을 서비스 해 드립니다.") }}</strong>
                    <p
                      class="fsmall"
                      v-html="
                        localize('R2 Planner는 임플란트 수술 가이드부터<br/>보철물 디자인까지, In-Lab을 위한<br/>디자인 서비스를 제공합니다.<br/>내 진료 스타일에 꼭 맞는,<br/>나만의 플래너를 찾아보세요.')
                      "
                    ></p>
                  </li>
                  <li class="col-lg-4">
                    <img src="@/assets/home/img/main/system-3.svg" class="ani" alt="" />
                    <strong class="fs-4">{{ localize("디지털 전문 파트너 랩, R2Center")}}</strong>
                    <p
                      class="fsmall"
                      v-html="
                        localize('전 세계의 디지털 보철 전문 R2 Center에서는<br/>R2 Guide, 임플란트, 무치악, 구강악안면 특수 보철까지 완성도<br/>높은 보철물을 서비스 합니다.')
                      "
                    ></p>
                  </li>
                </ul>

                <p class="d-lg-none text-center pt-3">
                  <a @click="openInNewTab('/playground/player/order')" class="btn btn-primary ml-0"
                    >{{ localize("바로 주문하기") }}<i class="icon icon-arrow"></i
                  ></a>
                  <button @click="alert(localize('준비 중 입니다.'))" class="btn btn-outline-primary mt-2 ml-0">
                    {{ localize("Playground 다운로드") }}<i class="icon icon-download"></i>
                  </button>
                </p>
              </div>
            </swiper-slide>
          </swiper>
        </swiper-slide>
        <swiper-slide class="main-sect main-academy text-center" :key="4">
          <div class="container">
            <h2 class="main-academy-title font-poppins">
              R2 <br class="d-lg-none" />Academy
              <img src="@/assets/home/img/main/academy2.svg" class="ani" alt="" />
            </h2>
            <div class="acdemy-illu">
              <div class="position-relative ani">
                <i class="aillu1"></i>
                <img src="@/assets/home/img/main/aillu1.svg" class="position-relative" alt="" />
              </div>
              <i class="aillu2 ani"></i>
              <i class="aillu3 ani"></i>
            </div>
            <strong class="main-academy-subtitle font-poppins">Learn together</strong>
            <p
              class="fsmall"
              v-html="
                localize('R2GATE가 처음이세요?<br/>여기 Tutorial 영상부터 응용까지 다양한 교육 컨텐츠를 준비했습니다.<br>R2GATE에 익숙하신 편이신가요?<br class=\'d-lg-none\' /> Professional R2 Planner를 위한 Course 및<br>Qualification test에 도전하셔도 좋습니다.')
              "
            ></p>
            <a @click="openYouTube" class="btn btn-primary">R2Playground TV<i class="icon icon-arrow"></i></a>
          </div>
        </swiper-slide>
        <swiper-slide class="swiper-slide main-sect main-play" :key="5">
          <div class="container ani ani-ink-left">
            <div class="main-play-hd">
              <div class="main-play-title">
                <h2 class="fs-3">R2 Playground</h2>
                <p>{{ localize("세대와, 세계를 잇습니다") }}</p>
              </div>
              <p
                class="mx-auto fsmall"
                v-html="
                  localize('<strong>Total Health Care Innovator</strong>라는 메가젠 임플란트의 사명 아래,<br/>R2 Playground는 임상에서 축적된 치과 의료 지식과 경험을 디지털<br/>플랫폼으로 융합하여 다음 세대에 계승되고 지속적으로 발전할 수 있<br/>는, 세대와 세계를 잇는 디지털 지식 플랫폼을 지향합니다.')
                "
                style="height: 100%; align-self: start;"
              ></p>
              <div class="swiper-button-wrap type-line">
                <div class="swiper-button-prev"></div>
                <div class="swiper-button-next"></div>
              </div>
            </div>
            <swiper
              class="play-swiper overflow-visible"
              :slides-per-view="1.08"
              :space-between="20"
              :grab-cursor="true"
              :modules="[Navigation, Pagination]"
              :navigation="{
                nextEl: '.main-play-hd .swiper-button-next',
                prevEl: '.main-play-hd .swiper-button-prev',
              }"
              :pagination="{
                el: '.play-swiper .swiper-pagination',
                type: 'progressbar',
              }"
              :breakpoints="{
                768: {
                  slidesPerView: 2.2,
                  spaceBetween: 30,
                },
                1024: {
                  slidesPerView: 3,
                  spaceBetween: 60,
                },
              }"
            >
              <swiper-slide>
                <div class="card">
                  <div class="card-img"><img src="@/assets/home/img/main/play1.png" alt="" /></div>
                  <strong class="fs-4">Share to continue</strong>
                  <p
                    class="card-text"
                    v-html="
                      localize('지식과 경험은 은퇴할수 없습니다.<br>R2 Playground는 당신과 당신의 지식과 경험을 필요로 하는 전세계의 Clinician들을 연결하는 디지털 플랫폼입니다.')
                    "
                  ></p>
                </div>
              </swiper-slide>
              <swiper-slide>
                <div class="card">
                  <div class="card-img"><img src="@/assets/home/img/main/play2.png" alt="" /></div>
                  <strong class="fs-4">You are not alone…</strong>
                  <p
                    class="card-text"
                    v-html="
                      localize('전문가가 되기 위해서, 모든 실패를 경험할 필요는 없습니다.<br>R2 Playground에서 다양한 경험을 가진 전문가 혹은 멘토를 찾아 도움을 구해 보세요. R2 Playground는 당신과 세계를 연결합니다.')
                    "
                  ></p>
                </div>
              </swiper-slide>
              <swiper-slide>
                <div class="card">
                  <div class="card-img"><img src="@/assets/home/img/main/play3.png" alt="" /></div>
                  <strong class="fs-4">{{ localize("세대와 세계를 잇다") }}</strong>
                  <p
                    class="card-text"
                    v-html="
                      localize('디지털 혁명의 핵심은 커뮤니케이션의 혁신에 있습니다. <br>R2 Playground는 끊임없이 진화하는 디지털 기술과 융합, 보다 직접적이고, 직관적으로 개인과 세계, 세대와 세대를 연결하는 소통의 채널이 될것입니다.')
                    "
                  ></p>
                </div>
              </swiper-slide>
              <swiper-slide>
                <div class="card">
                  <div class="card-img"><img src="@/assets/home/img/main/play4.png" alt="" /></div>
                  <strong class="fs-4">{{ localize("생각하는 도구로써의 디지털") }}</strong>
                  <p class="card-text">
                    {{
                      localize("디지털 기술은 완전히 새로운 것을 창조하는 것보다는, 이전 세대의 지식과 경험을 정량적으로 축적하고, 보다 많은 사람들에게 공유하며, 계승 발전시키는 도구로서 가치가 있습니다. R2 Playground는 첨단기술과의의 융합을 통해 더 많은 의료 전문가들이 함께 즐길 수 있는 솔루션을 제공합니다.")
                    }}
                  </p>
                </div>
              </swiper-slide>
              <swiper-slide class="swiper-pagination"></swiper-slide>
            </swiper>
          </div>
        </swiper-slide>
        <swiper-slide class="swiper-slide main-sect main-down text-center" :key="6">
          <div class="container">
            <img src="@/assets/home/img/main/r2i3.png" alt="R2i3 Icon" style="padding-bottom: 35px"/>
            <!-- <div ref="originRef" class="cube-wrap">
              <div class="cube">
                <div class="front"></div>
                <div class="back"></div>
                <div class="top"></div>
                <div class="btm"></div>
                <div class="left"></div>
                <div class="right"></div>
              </div>
            </div> -->
            <h2 class="fs-2">
              Scan & Play, R2 Playground
            </h2>
            <p class="fs-4">{{ localize("치과인의 글로벌 지식 네트워크 R2 Playground,지금 시작해 보세요") }}</p>
            <a v-bind:href="downloadLink" target="_blank"><button class="btn btn-primary justify-content-center">
              {{ localize("R2iOS 다운로드") }}
            </button></a>
          </div>
        </swiper-slide>

        <!-- footer -->
        <swiper-slide :key="7">
          <home-footer />
        </swiper-slide>
        <!-- //footer -->

        <div class="swiper-button-next swiper-button-next"></div>
      </swiper>
      <!-- //페이지 시작 -->
    </main>
    <!-- //container -->

    <!-- <div ref="floatRef" id="cube" class="cube-wrap">
      <div class="cube">
        <div class="front"></div>
        <div class="back"></div>
        <div class="top"></div>
        <div class="btm"></div>
        <div class="left"></div>
        <div class="right"></div>
      </div>
    </div> -->

    <button class="app-link" @click="onClickAppDownload('PINGPONG', 'windows')">
      <img src="@/assets/home/img/pingpong-motion.gif" alt="" />
      <div
        ref="downloadSectionRef"
        class="download-section count-num"
        data-type="PINGPONG"
      >
        (00000)
      </div>
    </button>
    <!-- <button class="app-link" title="APP DOwnload"> -->
      <!-- <a v-bind:href="downloadLink" target="_blank"><i class="app-link-line"></i></a> -->
    <!-- </button> -->

    <!-- footer -->

    <!-- //footer -->
  </div>
</template>

<style scoped>
.together-btn-group {
  display: flex;
  gap: 15px;
}
.custom-min-width {
  min-width: 100px;;
}
.nav-card__content-img-group {
  display: flex;
  justify-content: end;
  gap: 14px;
}
.r2ios-logo-img-group {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.nav-card-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr); /* 2열 구조 */
  /* gap: 50px; 행과 열 간격 */
  gap: 40px;
  margin: 48px 0;
}

.nav-card,
.nav-card-not-hover
{
  background-color: white;
  border-radius: 18px;
  box-shadow: 4px 8px 8px 0 rgba(0, 0, 0, 0.33);
  border: none;
  /* padding: 18px 25px; */
  padding: 15px 19px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  /* width: 430px; */
  width: 350px;
  height: 110px;
  box-sizing: border-box;
  transition: transform 0.5s ease;
}

.nav-card.sign-up {
  width: 100%;
  padding-left: 48px;
}
.nav-card:not(.disabled):hover {
  transform: scale(1.1);
}

.nav-card.disabled {
  opacity: 0.5;
  pointer-events: none;
}

.nav-card__title {
  font-size: 16px;
  font-weight: 800;
  margin-bottom: 5px;
}

.nav-card__content,
.nav-card__content-manual {
  font-size: 12px;
  font-weight: 400;
}

.nav-card__content-manual {
  cursor: pointer;
  color: blue;
  font-weight: 600;
}


.nav-card img {
  max-height: 40px;
}

.nav-card__content-img-group .nav-card-app-img {
  max-height: 45px;
  width: 45px;
  height: 45px;
}

.nav-card .arrow {
  width: 50px;
}

.r2i3-logo-top-logo {
  height: 30px;
  object-fit: contain;
  width: fit-content;
}
.sub-logo-group {
  display: flex;
  justify-content: space-between;
  height: 30px;
}
.nav-card__action,
.nav-card__action-route {
  display: flex;
  flex-direction: column;
  height: 100%;
  align-items: end;
  justify-content: center;
  gap: 15px;
}
.nav-card.download {
  cursor: pointer;
}

.nav-card__action-route {
  cursor: pointer;
  justify-content: center;
}

.sns-logo-group {
  position: absolute;
  display: flex;
  gap: 15px;
  bottom:-20%;
  right: 0;
}
.sns-logo-group img {
  height: 30px;
}
.visual-illu {
  transform: translateX(100px);
}
.sign-up-title {
  font-weight: 800;
  font-size: 25px;
}
</style>
